//
//
//
//
//
//
//

export default {
  data(){
    return {
    }
  },
  props:['camp'],
  mounted() {

  },
}



// WEBPACK FOOTER //
// ./src/components/activity/Activity.vue